import { useEffect, useRef } from 'react';
import { useAuth } from '@clerk/clerk-react';
import { apiHeaders, apiUrl } from '../lib/api';
import {
  clearPendingReferralCode,
  loadPendingReferralCode,
} from '../lib/localStore';

/**
 * After signup, claim a pending /r/{code} referral once.
 * Existing / older accounts are rejected by the API (not_new_user).
 */
export function ReferralClaimRunner() {
  const { isSignedIn, getToken } = useAuth();
  const ranRef = useRef(false);

  useEffect(() => {
    if (!isSignedIn || ranRef.current) return;

    const code = loadPendingReferralCode();
    if (!code) return;

    ranRef.current = true;
    let cancelled = false;

    (async () => {
      try {
        const token = await getToken();
        if (cancelled) return;
        await fetch(apiUrl('/api/referrals/claim'), {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...apiHeaders(token),
          },
          body: JSON.stringify({ code }),
        });
      } catch {
        // best-effort; clear anyway so we don't loop forever
      } finally {
        clearPendingReferralCode();
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [isSignedIn, getToken]);

  return null;
}

export default ReferralClaimRunner;
